<ul *ngIf="pratica">
	<li *ngIf="isViewPraticaView && urlPathViewPratica"><span class="glyphicon glyphicon-eye-open"></span>
	<a [routerLink]="urlPathViewPratica">Visualizza pratica</a></li>

	<li
		*ngIf="descrittoreCreazionePratica && !pratica.archiviata && !pratica.riunita">
		<a href="javascript:void(0);" (click)="onClickOption('addFascicolo',pratica);">
		<span class="glyphicon glyphicon-plus-sign"></span>Aggiungi fascicolo</a></li>

	<li
		*ngIf="!descrittoreCreazionePratica || pratica.archiviata || pratica.riunita"
		class="disabilitata"><span class="glyphicon glyphicon-plus-sign"></span>Aggiungi
		fascicolo</li>

	<li
		*ngIf="descrittoreCancellazione && !pratica.archiviata && !pratica.definito && !pratica.riunita && !pratica.capofila"><a
		href="javascript:void(0);" (click)="onClickDelete(pratica)"
		delete-pratica #deletePratica></a></li>

	<li
		*ngIf="!descrittoreCancellazione || pratica.archiviata || pratica.definito || pratica.riunita || pratica.capofila"
		class="disabilitata"><span class="glyphicon glyphicon-trash"></span>Elimina
		pratica</li>

	<li><a href="javascript:void(0);" target="_blank"
		[routerLink]="['/scheda_analitica/pratica', pratica.id, pratica.tipoPratica.id]"><span
			class="glyphicon glyphicon-print"></span>Scheda analitica</a></li>

	<li><a href="javascript:void(0);" target="_blank"
		[routerLink]="['/scheda_sintetica/pratica', pratica.id, pratica.tipoPratica.id]"><span
			class="glyphicon glyphicon-print"></span>Scheda sintetica</a></li>

	<li
		*ngIf="pratica.tipoPratica.id !== ID_PRATICA_PARERISTICA && descrittoreCopiaPratica && !pratica.archiviata && !pratica.riunita">
		<span
			class="glyphicon glyphicon-copy"></span><a
		href="javascript:void(0);"
		(click)="onClickOption('copiaPratica',pratica);">Copia pratica</a></li>

	<li>
		<span
			class="glyphicon glyphicon-search"></span><a
		href="javascript:void(0);"
		(click)="onClickOption('ricercaPrecedenti',pratica);">Ricerca precedenti</a></li>

	<li
		*ngIf="pratica.tipoPratica.id === ID_PRATICA_PARERISTICA || !descrittoreCopiaPratica || pratica.archiviata || pratica.riunita"
		class="disabilitata"><span class="glyphicon glyphicon-copy"></span>Copia
		pratica</li>

	<li
		*ngIf="descrittoreArchiviazione && pratica.definito && !pratica.archiviata && !pratica.riunita"><a
		href="javascript:void(0);"
		(click)="onClickOption('archiviaPratica',pratica);"><span
			class="glyphicon glyphicon-floppy-saved"></span>Archivia pratica</a></li>

	<li
		*ngIf="!descrittoreArchiviazione || !pratica.definito || pratica.archiviata || pratica.riunita"
		class="disabilitata"><span
		class="glyphicon glyphicon-floppy-saved"></span>Archivia pratica</li>


	<li *ngIf="!pratica.archiviata && descrittoreCorrelaPratica"><span
		class="glyphicon glyphicon-link"></span><a href="javascript:void(0);"
		(click)="onClickOption('correlaPratica',pratica);">Correla pratica</a></li>

	<li *ngIf="pratica.archiviata || !descrittoreCorrelaPratica" class="disabilitata"><span
		class="glyphicon glyphicon-link"></span>Correla pratica</li>

	<li *ngIf="location === 'pratiche_correlate' && descrittoreCorrelaPratica"><a href="javascript:void(0);"
		(click)="onClickOption('eliminaCorrelazione',pratica);"><span
			class="glyphicon glyphicon-trash"></span>Elimina correlazione</a></li>

  <li *ngIf="location === 'pratiche_precedenti' && descrittorePraticaPrecedente"><a href="javascript:void(0);"
		(click)="onClickOption('eliminaPrecedente',pratica);"><span
			class="glyphicon glyphicon-trash"></span>Elimina precedente</a></li>

</ul>
